﻿export class FileUploadCancelRequested {
    static eventName() { return 'FileUploadCancelRequested'; }
    eventName = FileUploadCancelRequested.eventName;

    constructor(public transferId: string) { }
}